import type { FaxItem } from '../../services/faxItems';

/**
 * What to call a row that nobody has named.
 *
 * A stand-in rather than a stored default, so the rename field opens empty and
 * somebody is naming the thing rather than editing a sentence we wrote. An
 * assembled document always has a name, because naming it is part of making it.
 */
export function displayName(
  item: Pick<FaxItem, 'name' | 'fax_number_from'>
): string {
  if (item.name && item.name.trim()) return item.name;
  if (item.fax_number_from && item.fax_number_from.trim()) {
    return `Fax from ${item.fax_number_from}`;
  }
  return 'Fax';
}
